/**
 * Relógio do servidor visto daqui — conserto do "5 s configurado, anel começa
 * em 6" (e sobra ~1 s de anel depois de a mensagem já ter saído).
 *
 * O prazo do agrupador (`batch_open_until`) é hora do SERVIDOR; o anel contava
 * contra `Date.now()` da aba. Relógio da máquina do atendente atrás do
 * servidor → sobra tempo a mais (5,8 s → `ceil` → 6); à frente → falta (o anel
 * some antes de a mensagem sair). Já medimos os dois sentidos em produção
 * (vide carimbo-da-bolha.ts).
 *
 * Estimativa sem endpoint novo: a resposta do `POST /messages` traz
 * `server_now`, a hora do servidor ao responder — um instante entre o envio
 * e a chegada da resposta. `desvio ≈ server_now − meio do intervalo`, com
 * erro de no máximo meia ida-e-volta (~50–150 ms). (Não serve o `created_at`
 * da mesma resposta: texto que entra num pacote aberto devolve o da âncora,
 * segundos atrás.) Mediana das últimas amostras pra uma resposta lenta
 * isolada não puxar a estimativa. Sem amostra ainda (aba recém-aberta, ou
 * backend antigo sem o campo) → desvio 0, o comportamento de sempre.
 */

const MAXIMO_DE_AMOSTRAS = 5;
/** Ida-e-volta acima disso é rede engasgada — a amostra diz pouco, descarta. */
const IDA_E_VOLTA_MAXIMA_MS = 5_000;

let amostras: number[] = [];

function mediana(valores: readonly number[]): number {
  const ordenados = [...valores].sort((a, b) => a - b);
  const meio = Math.floor(ordenados.length / 2);
  return ordenados.length % 2 === 1
    ? ordenados[meio]!
    : (ordenados[meio - 1]! + ordenados[meio]!) / 2;
}

/**
 * Registra uma amostra: `servidorIso` é um carimbo que o servidor gerou
 * durante uma requisição que começou em `antesMs` e terminou em `depoisMs`
 * (relógio local). Ignora carimbo inválido e ida-e-volta longa demais.
 */
export function registrarAmostraDoRelogio(
  servidorIso: string | null | undefined,
  antesMs: number,
  depoisMs: number,
): void {
  if (!servidorIso) return;
  const servidor = Date.parse(servidorIso);
  if (Number.isNaN(servidor)) return;
  const idaEVolta = depoisMs - antesMs;
  if (idaEVolta < 0 || idaEVolta > IDA_E_VOLTA_MAXIMA_MS) return;
  amostras.push(servidor - (antesMs + depoisMs) / 2);
  if (amostras.length > MAXIMO_DE_AMOSTRAS) amostras = amostras.slice(-MAXIMO_DE_AMOSTRAS);
}

/** Quanto o servidor está à frente (+) ou atrás (−) da aba, em ms. 0 sem amostras. */
export function desvioDoRelogioMs(): number {
  return amostras.length === 0 ? 0 : mediana(amostras);
}

/** `Date.now()` corrigido pro relógio do servidor. Use pra comparar com prazos vindos dele. */
export function agoraDoServidor(): number {
  return Date.now() + desvioDoRelogioMs();
}

/** Só pra teste. */
export function zerarAmostrasDoRelogio(): void {
  amostras = [];
}
